import {
  AcademicCapIcon,
  BuildingOffice2Icon,
} from "@heroicons/react/16/solid"
import { ReviewType } from "../../features/reviews/api/adminReviews.api"

export type ReviewTypeMeta = {
  type: ReviewType
  label: string
  description: string
  icon: React.ReactNode
  color: string
  gradient: string
  targetLink: (id: string) => string
}

export const REVIEW_TYPES: ReviewTypeMeta[] = [
  {
    type: "course",
    label: "Курсы",
    description: "Отзывы студентов на курсы менторов",
    icon: <AcademicCapIcon className="w-5 h-5" />,
    color: "text-emerald-600 bg-emerald-50",
    gradient: "from-emerald-500 to-green-400",
    targetLink: (id) => `/courses/${id}`,
  },
  {
    type: "enterprise",
    label: "Китайские предприятия",
    description: "Отзывы на карточки китайских предприятий",
    icon: <BuildingOffice2Icon className="w-5 h-5" />,
    color: "text-red-600 bg-red-50",
    gradient: "from-red-500 to-rose-400",
    targetLink: () => `/china-enterprises`,
  },
]

export const REVIEW_TYPE_MAP: Record<ReviewType, ReviewTypeMeta> = Object.fromEntries(
  REVIEW_TYPES.map((t) => [t.type, t])
) as Record<ReviewType, ReviewTypeMeta>

export const isReviewType = (v: string): v is ReviewType =>
  REVIEW_TYPES.some((t) => t.type === v)